import { useRedux } from '../../../../hooks';
import { profileLoadUserData } from '../../../../redux/user/profile/actions';

export default function useProfile() {
    const { dispatch, appSelector } = useRedux();
    const { userProfileData } = appSelector((state) => ({
        apiSuccess: state.Profile.apiSuccess,
        userProfileData: state.Profile.userProfileData,
        loading: state.Profile.loading,
    }));

    const loadProfileUserData = (username: string) => {
        dispatch(profileLoadUserData(username));
    };

    return {
        userProfileData,
        loadProfileUserData,
    };
}
